module.exports = __webpack_public_path__ + "img/chartImage.ae142ad0.jpg";